// Local sample products for testing without Firestore
// These products will be used when Firestore is not available

export const sampleProducts = [
  // Powders
  {
    id: 'ash-powder-001',
    name: 'Ashwagandha Powder',
    category: 'Powders',
    price: 90,
    description: 'A powerful adaptogenic herb known for reducing stress, improving mood, and supporting overall vitality. Ashwagandha enhances energy levels, boosts hormonal balance, and promotes restful sleep for improved daily wellbeing.',
    tags: ['Powders', 'Wellness', 'Stress Relief'],
    status: 'active',
    size: '100g',
    imageUrl: '/Gs.png', // Placeholder - replace with actual product image
    createdAt: new Date('2024-01-15')
  },
  {
    id: 'mor-powder-002',
    name: 'Moringa Powder',
    category: 'Powders',
    price: 70,
    description: 'A nutrient-dense green superfood packed with vitamins, minerals, and antioxidants. Moringa supports immune health, boosts energy, balances blood sugar, and promotes healthy skin and digestion.',
    tags: ['Powders', 'Superfood', 'Energy'],
    status: 'active',
    size: '100g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-01-16')
  },
  {
    id: 'mac-powder-003',
    name: 'Maca Root Powder',
    category: 'Powders',
    price: 100,
    description: 'A powerful Peruvian superfood prized for boosting energy, balancing hormones, enhancing libido, and supporting fertility. Maca helps improve mood, stamina, and overall vitality.',
    tags: ['Powders', 'Energy', 'Wellness'],
    status: 'active',
    size: '100g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-01-17')
  },
  {
    id: 'fer-powder-004',
    name: 'Fertility Powder',
    category: 'Powders',
    price: 80,
    description: 'A nourishing herbal blend formulated to support reproductive health. This powder helps balance hormones, strengthen the womb, enhance ovulation, and improve natural fertility for couples trying to conceive.',
    tags: ['Powders', 'Wellness', 'Fertility'],
    status: 'active',
    size: '100g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-01-18')
  },
  {
    id: 'fen-powder-005',
    name: 'Fenugreek Powder',
    category: 'Powders',
    price: 70,
    description: 'A nutrient-rich powder traditionally used to support digestion, regulate blood sugar, and assist with hormonal balance. Fenugreek is also known to increase breastmilk production and support healthy weight gain.',
    tags: ['Powders', 'Wellness', 'Digestion'],
    status: 'active',
    size: '100g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-01-19')
  },
  {
    id: 'gin-powder-006',
    name: 'Ginkgo Biloba Powder',
    category: 'Powders',
    price: 90,
    description: 'A natural brain-boosting herb that enhances memory, concentration, and mental clarity. Ginkgo supports healthy circulation and overall cognitive performance.',
    tags: ['Powders', 'Brain Health', 'Focus'],
    status: 'active',
    size: '100g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-01-20')
  },
  {
    id: 'sou-powder-007',
    name: 'Soursop Powder',
    category: 'Powders',
    price: 120,
    description: 'A potent antioxidant-rich herbal powder known for its immune-boosting properties. Soursop supports detoxification, digestive health, improved sleep, and overall wellness.',
    tags: ['Powders', 'Immunity', 'Wellness'],
    status: 'active',
    size: '100g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-01-21')
  },

  // Teas
  {
    id: 'hib-tea-008',
    name: 'Hibiscus Tea',
    category: 'Teas',
    price: 70,
    description: 'Bright, refreshing, and rich in antioxidants. Hibiscus tea supports healthy blood pressure, promotes heart health, and aids digestion while offering a naturally tangy flavour.',
    tags: ['Teas', 'Wellness', 'Heart Health'],
    status: 'active',
    size: '35g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-01-22')
  },
  {
    id: 'dre-tea-009',
    name: 'Dream Catcher Tea',
    category: 'Teas',
    price: 100,
    description: 'A calming, intuitive-enhancing tea crafted to clarify dreams, improve sleep quality, and support spiritual sensitivity. Ideal for bedtime relaxation and dream work.',
    tags: ['Teas', 'Sleep', 'Relaxation'],
    status: 'active',
    size: '35g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-01-23')
  },
  {
    id: 'fer-tea-010',
    name: 'Fertility Tea',
    category: 'Teas',
    price: 120,
    description: 'A gentle yet powerful herbal blend that supports reproductive health, balances hormones, prepares the womb, and enhances natural fertility for couples planning to conceive.',
    tags: ['Teas', 'Wellness', 'Fertility'],
    status: 'active',
    size: '35g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-01-24')
  },
  {
    id: 'imb-tea-011',
    name: 'Imbiza ye Gazi Tea',
    category: 'Teas',
    price: 120,
    description: 'A traditional African herbal blend used to cleanse and strengthen the blood. This tea promotes detoxification, boosts immunity, and supports overall health and vitality.',
    tags: ['Teas', 'Detox', 'Traditional'],
    status: 'active',
    size: '85g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-01-25')
  },
  {
    id: 'sou-tea-012',
    name: 'Soursop Leaves Tea',
    category: 'Teas',
    price: 90,
    description: 'A soothing herbal tea made from dried soursop leaves. Known for supporting immunity, reducing inflammation, calming the body, and promoting deep, restful sleep.',
    tags: ['Teas', 'Sleep', 'Immunity'],
    status: 'active',
    size: '85g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-01-26')
  },

  // Steaming Range
  {
    id: 'yon-steam-013',
    name: 'Yoni Steaming Herbs',
    category: 'Steaming',
    price: 100,
    description: 'A gentle, traditional feminine wellness vaginal steaming blend crafted to support womb health, emotional balance, and energetic cleansing. Ideal for women seeking deeper connection with their feminine essence.',
    tags: ['Steaming', 'Wellness', 'Feminine Care'],
    status: 'active',
    size: '30g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-01-27')
  },
  {
    id: 'imp-steam-014',
    name: 'Imphepho',
    category: 'Steaming',
    price: 70,
    description: 'One of South Africa\'s most sacred traditional herbs, used for cleansing, protection, meditation, and communicating with ancestors. Perfect for cleansing your home and creating a peaceful spiritual atmosphere.',
    tags: ['Steaming', 'Spiritual', 'Cleansing'],
    status: 'active',
    size: '50g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-01-28')
  },
  {
    id: 'hla-steam-015',
    name: 'IsiFutho SokuHlanzeka',
    category: 'Steaming',
    price: 250,
    description: 'A powerful spiritual steaming blend for deep cleansing and purification of the aura. Removes heavy energy and restores balance, peace, and clarity. Strictly for steaming, not bathing.',
    tags: ['Steaming', 'Spiritual', 'Cleansing'],
    status: 'active',
    size: '80g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-01-29')
  },
  {
    id: 'nqo-steam-016',
    name: 'IsiFutho SokuNqobizitha',
    category: 'Steaming',
    price: 250,
    description: 'A protective, empowering steam blend for overcoming obstacles and blockages. Strengthens spiritual armour, enhances confidence, and helps break through resistance. Strictly for steaming.',
    tags: ['Steaming', 'Spiritual', 'Protection'],
    status: 'active',
    size: '80g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-01-30')
  },

  // Soaps
  {
    id: 'cha-soap-017',
    name: 'Charcoal Soap',
    category: 'Soaps',
    price: 180,
    description: 'A deep-cleansing detox bar that purifies the skin and removes impurities. Activated charcoal draws out dirt, oil, and toxins, ideal for acne-prone or congested skin.',
    tags: ['Soaps', 'Skincare', 'Cleansing'],
    status: 'active',
    size: '100g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-02-01')
  },
  {
    id: 'tur-soap-018',
    name: 'Turmeric and Honey Soap',
    category: 'Soaps',
    price: 150,
    description: 'A brightening, soothing bar enriched with turmeric and honey. Helps reduce inflammation, even out skin tone, and revive dull skin while deeply hydrating.',
    tags: ['Soaps', 'Skincare', 'Natural'],
    status: 'active',
    size: '100g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-02-02')
  },
  {
    id: 'goa-soap-019',
    name: 'Goat Milk Soap',
    category: 'Soaps',
    price: 150,
    description: 'A creamy, luxurious soap for sensitive or dry skin. Rich in vitamins and minerals, creates a soft lather that leaves skin silky smooth. Helps soothe eczema and inflammation.',
    tags: ['Soaps', 'Skincare', 'Sensitive Skin'],
    status: 'active',
    size: '100g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-02-03')
  },
  {
    id: 'hon-soap-020',
    name: 'Honey & Oatmeal Soap',
    category: 'Soaps',
    price: 150,
    description: 'A comforting bar with real honey and oatmeal. Gently exfoliates while soothing dry, itchy skin. Provides antibacterial benefits and deep hydration for naturally radiant skin.',
    tags: ['Soaps', 'Skincare', 'Exfoliation'],
    status: 'active',
    size: '100g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-02-04')
  },

  // Scrubs
  {
    id: 'van-scrub-021',
    name: 'Vanilla and Cinnamon Scrub',
    category: 'Scrubs',
    price: 180,
    description: 'A warm, aromatic exfoliating scrub that softens and brightens skin. Sweet vanilla blends with stimulating cinnamon to promote circulation and reveal natural glow.',
    tags: ['Scrubs', 'Skincare', 'Exfoliation'],
    status: 'active',
    size: '250ml',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-02-05')
  },
  {
    id: 'cof-scrub-022',
    name: 'Coffee Scrub',
    category: 'Scrubs',
    price: 180,
    description: 'An energizing scrub that exfoliates and detoxifies. Coffee grounds smooth skin, reduce cellulite appearance, and improve circulation for refreshed, glowing skin.',
    tags: ['Scrubs', 'Skincare', 'Detox'],
    status: 'active',
    size: '250ml',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-02-06')
  },
  {
    id: 'cha-scrub-023',
    name: 'Charcoal Scrub',
    category: 'Scrubs',
    price: 220,
    description: 'A deep detox scrub that draws out impurities and unclogs pores. Perfect for oily or congested skin. Excellent for full-body spiritual cleansing.',
    tags: ['Scrubs', 'Skincare', 'Detox'],
    status: 'active',
    size: '250ml',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-02-07')
  },
  {
    id: 'hon-scrub-024',
    name: 'Honey and Lemon Scrub',
    category: 'Scrubs',
    price: 180,
    description: 'A brightening blend that softens and rejuvenates dull skin. Honey hydrates while lemon gently lightens dark marks and exfoliates. Leaves skin glowing with uplifting citrus aroma.',
    tags: ['Scrubs', 'Skincare', 'Brightening'],
    status: 'active',
    size: '250ml',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-02-08')
  },

  // Bath Herbs
  {
    id: 'nhl-bath-025',
    name: 'Isiwasho seNhlanhla',
    category: 'Bath Herbs',
    price: 120,
    description: 'A spiritual bath soak designed to attract luck, blessings, and positive energy. Helps clear bad luck and invite abundance. Perfect for new beginnings and important life events.',
    tags: ['Bath Herbs', 'Spiritual', 'Luck'],
    status: 'active',
    size: '80g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-02-09')
  },
  {
    id: 'vul-bath-026',
    name: 'Isiwasho sokuVulindlela',
    category: 'Bath Herbs',
    price: 120,
    description: 'A powerful path-opening herbal soak that removes spiritual blockages. Supports success in finances, career, relationships, and personal goals by restoring flow and alignment.',
    tags: ['Bath Herbs', 'Spiritual', 'Success'],
    status: 'active',
    size: '80g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-02-10')
  },
  {
    id: 'mad-bath-027',
    name: 'Isiwasho saMadlozi',
    category: 'Bath Herbs',
    price: 150,
    description: 'A sacred ancestral connection bath soak for guidance and grounding. Strengthens your link with ancestors, inviting protection, wisdom, and spiritual alignment.',
    tags: ['Bath Herbs', 'Spiritual', 'Ancestral'],
    status: 'active',
    size: '80g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-02-11')
  },

  // Weight Management
  {
    id: 'wei-gain-028',
    name: 'Weight Gain Oats-Porridge (Original)',
    category: 'Weight Management',
    price: 70,
    description: 'A rich, high-calorie nutritional blend designed to support healthy weight gain. Made with energy-dense whole grains and herbs that promote appetite and build strength.',
    tags: ['Weight Management', 'Nutrition', 'Wellness'],
    status: 'active',
    size: '100g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-02-12')
  },
  {
    id: 'wei-gain-ban-029',
    name: 'Weight Gain Oats-Porridge (Banana)',
    category: 'Weight Management',
    price: 70,
    description: 'A creamy, banana-flavoured high-calorie porridge that boosts appetite, energy, and healthy weight gain. Delicious and nutritious.',
    tags: ['Weight Management', 'Nutrition', 'Wellness'],
    status: 'active',
    size: '100g',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-02-13')
  },
  {
    id: 'bel-bust-030',
    name: 'Belly Buster Paste',
    category: 'Weight Management',
    price: 150,
    description: 'A powerful herbal paste to support natural weight management. Helps boost metabolism, reduce bloating, detoxify digestion, and target stubborn belly fat for a healthier waistline.',
    tags: ['Weight Management', 'Detox', 'Wellness'],
    status: 'active',
    size: '250ml',
    imageUrl: '/Gs.png',
    createdAt: new Date('2024-02-14')
  }
];

// Get unique categories
export const categories = ['All', ...new Set(sampleProducts.map(p => p.category))];

// Get unique tags
export const tags = [...new Set(sampleProducts.flatMap(p => p.tags))];

export default sampleProducts;
